import { defineMessages } from 'react-intl';

export default defineMessages({
    needHelp: {
        id: 'portal.index.Need Help',
        defaultMessage: 'Help Center/Contact Us',
    },
    legalPrivacy: {
        id: 'portal.index.Privacy',
        defaultMessage: 'Legal & Privacy',
    },
    customerCare: {
        id: 'portal.index.Customer Care',
        defaultMessage: 'Customer Care: 1.800.231.1363'
    },
    search: {
        id: 'portal.index.Search',
        defaultMessage: 'Search'
    }
});